import { useAppContext } from "@context/app";
import { useLayoutContext } from "@context/layout";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import useScrollspy from "@shared/hooks/useScrollSpy";
import { ProgramCategory } from "@types";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useProgramConds = (categories: ProgramCategory[]) => {
  const { showFestivalBanner } = useAppContext();
  const isLessThan768 = useIsMobile(768);
  const { isAdmin } = useLayoutContext();
  const { back, push } = useRouter();

  const [showBanner, setShowBanner] = useState(showFestivalBanner);

  const offsetTop = isAdmin
    ? isLessThan768
      ? 101
      : 110
    : isLessThan768
      ? 51
      : 60;

  const navOffsetTop = isAdmin
    ? showBanner
      ? "106px"
      : "50px"
    : showBanner
      ? "56px"
      : "0px";

  const scrollMargin = isLessThan768
    ? isAdmin
      ? 150
      : 100
    : isAdmin
      ? 100
      : 50;

  const activeIndex = useScrollspy(
    categories.map((category) => `${category.id}-programs`) || [],
    isLessThan768 ? 164 : 128
  );

  useEffect(() => {
    const handleScroll = () => {
      setShowBanner(showFestivalBanner ? window.scrollY < 500 : false);
    };
    setShowBanner(showFestivalBanner || false);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showFestivalBanner]);

  const backHandler = () => {
    if (typeof window !== "undefined" && window?.history?.length > 1) back();
    else push("/program");
  };

  return {
    showBanner,
    offsetTop,
    scrollMargin,
    activeIndex,
    navOffsetTop,
    backHandler,
  };
};

export default useProgramConds;
